import { c as _c } from "react/compiler-runtime";
import { SessionsLayout } from '@src/components/sco/Advisors/layout/SessionsLayout';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { SessionBookForm } from '@src/components/sco/Advisors/sections/SessionBookForm';
import { AdvisorsQueryState } from '@src/components/sco/Advisors/shared/AdvisorsQueryState';
import { acceptingSessionsDirectoryHref } from '@src/components/sco/Advisors/utils/directoryFilters';
import { advisorBookSessionPath } from '@src/components/sco/Advisors/utils/sessionFeeWaiveCode';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

/** In-app book flow under Advisors chrome. Public share links use `/members/{slug}/book`. */
export const SessionBookSection = () => {
  const $ = _c(24);
  const paths = useAdvisorsPaths();
  const {
    currentUser
  } = useCurrentUser();
  const isGuest = !currentUser || !!currentUser.isGuest;
  const router = useRouter();
  let t0;
  if ($[0] !== router.isReady || $[1] !== router.query) {
    t0 = router.isReady ? String(router.query.expertUserId || "").trim() : "";
    $[0] = router.isReady;
    $[1] = router.query;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const expertUserId = t0;
  let t1;
  if ($[3] !== router.isReady || $[4] !== router.query) {
    t1 = router.isReady ? String(router.query.waive || "").trim() : "";
    $[3] = router.isReady;
    $[4] = router.query;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const waiveCode = t1;
  let t2;
  if ($[6] !== paths) {
    t2 = acceptingSessionsDirectoryHref(paths);
    $[6] = paths;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const directoryBookHref = t2;
  let t3;
  let t4;
  if ($[8] !== directoryBookHref || $[9] !== expertUserId || $[10] !== isGuest || $[11] !== router || $[12] !== waiveCode) {
    t3 = () => {
      if (!router.isReady) {
        return;
      }
      if (isGuest && expertUserId) {
        router.replace(advisorBookSessionPath(expertUserId, waiveCode || null));
        return;
      }
      if (!expertUserId) {
        router.replace(directoryBookHref);
      }
    };
    t4 = [directoryBookHref, expertUserId, isGuest, router, waiveCode];
    $[8] = directoryBookHref;
    $[9] = expertUserId;
    $[10] = isGuest;
    $[11] = router;
    $[12] = waiveCode;
    $[13] = t3;
    $[14] = t4;
  } else {
    t3 = $[13];
    t4 = $[14];
  }
  useEffect(t3, t4);
  const complimentary = !!waiveCode;
  const description = complimentary ? "This complimentary link waives session fees. Propose times that work for you \u2014 no card hold if the coupon is valid." : "Propose times that work for you. We\u2019ll hold the package on your card; you\u2019re charged when the expert confirms a slot.";
  if (!router.isReady || !expertUserId || isGuest) {
    let t5;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <AdvisorsQueryState loading={true}>{null}</AdvisorsQueryState>;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t6;
    if ($[16] !== description) {
      t6 = <SessionsLayout activeKey="book" description={description} title="Book a session">{t5}</SessionsLayout>;
      $[16] = description;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    return t6;
  }
  let t5;
  if ($[18] !== expertUserId || $[19] !== waiveCode) {
    t5 = <SessionBookForm expertUserId={expertUserId} waiveCode={waiveCode} />;
    $[18] = expertUserId;
    $[19] = waiveCode;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== description || $[22] !== t5) {
    t6 = <SessionsLayout activeKey="book" description={description} title="Book a session">{t5}</SessionsLayout>;
    $[21] = description;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
};